import React from "react";
import moment from "moment";
import { InputNumber } from "@loanbossinc/component-library";

import { CellContentWrapper, ButtonWrapper, Link } from "./dashboard.style";
import SelectFilter from "./SelectFilter";
import DateFilter from "./DateFilter";
import { EditableCell } from "./EditableCell";

export const columns = (goToDeal, update) => {
  const columns = [
    { Header: "Deal Name",
      accessor: "dealName",
      Cell: item => (
        <ButtonWrapper>
          <Link onClick={() => goToDeal(item.row.original.dealId, item.row.original.loanId)}>{item.row.values.dealName}</Link>
        </ButtonWrapper>
      ) }
  ];
  columns.push({ Header: "Lender",
    accessor: "lender",
    sortType: "basic",
    Filter: SelectFilter,
    Cell: item => (<CellContentWrapper>
      {" "}
      {item.value}
      {" "}
                   </CellContentWrapper>) });
  columns.push({ Header: "Closing Date", accessor: "closingDate", sortType: "basic", Filter: DateFilter, filter: "dateBetween", Cell: item => (<CellContentWrapper>{moment(item.value).format("MM/DD/YYYY")}</CellContentWrapper>) });
  columns.push({ Header: "Loan Amount",
    accessor: "loanAmount",
    sortType: "basic",
    Filter: SelectFilter,
    Cell: item => (<CellContentWrapper>
      {" "}
      {item.value}
      {" "}
                   </CellContentWrapper>) });
  columns.push({ Header: "Calculation Spread (%)", accessor: "spread", Cell: EditableCell });

  return [
    {
      Header: () => (<>Debt Valuation Spreads</>),
      id: "dv-spreads-header",
      columns
    }
  ];
};

